import { render, staticRenderFns } from "./UpdaterAdminCli.vue?vue&type=template&id=5ed20914"
import script from "./UpdaterAdminCli.vue?vue&type=script&setup=true&lang=ts"
export * from "./UpdaterAdminCli.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./UpdaterAdminCli.vue?vue&type=style&index=0&id=5ed20914&prod&module=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports